import React, { useContext } from 'react';
import { insightsContext } from '../../context/insightsContext';
import NavigationArrows from './NavigationArrows/NavigationArrows';
import Styles from './InsightNavigationBar.module.scss';

const InsightNavigationBar = (props) => {
  const insights = useContext(insightsContext);
  const { state } = insights;
  const { data, currentInsight } = state;
  const { fetchingAuthorInfo } = props;

  return (
    <div>
      <div className={Styles.mobileNavigator}>
        <div className={Styles.navigator}>
          <NavigationArrows fetchingAuthorInfo={fetchingAuthorInfo} />
        </div>
      </div>
      <div className={Styles.navigationBar}>
        {
          data
          && <div className={Styles.currentInsight}>
            <span>{data[currentInsight].menuTitle}</span>
            <span className={Styles.navigator}>
              <NavigationArrows fetchingAuthorInfo={fetchingAuthorInfo} />
            </span>
          </div>
        }
      </div>
    </div>
  );
};

export default InsightNavigationBar;
